import React, { useState, useContext, useEffect } from "react";
import Button from "../../atoms/Button";
import { Country, State, City } from "country-state-city";
import { AnimatePresence } from "framer-motion";
import OrganizationForm from "../../molecules/OrganizationForm";
import BillingForm from "../../molecules/BillingForm";
import BasicInformationForm from "../../molecules/BasicInformationForm";
import ContactDetailsForm from "../../molecules/ContactDetailsForm";
import { TopLoaderContext } from "../../../context/TopLoader";
import { Form, Checkbox } from "antd";
import { motion } from "framer-motion";
import "./style.css";
import { getkyc, kyc } from "../../../utils/API/kyc";
import toast from "react-hot-toast";
import { getAllRegistries } from "../../../utils/API/getAllRegistries";
import { getCountryAndStateName } from "../../../utils/helper/getCountryAndState";
import {
  fillkycTransformData,
  kycTransformData,
} from "../../../utils/helper/kyc-form";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import KycSignaturePopup from "../../atoms/KycSignaturePopup";

const doumentsDefaultState = {
  organizationInformationCompanyRegisteredAddress: [],
  organizationInformationCompanyTaxId: [],
  organizationInformationPanId: [],
  organizationInformationDunsNumber: [],
  user_goverment_issued_id: [],
};

const conteactDoumentsDefaultState = {
  goverment_issued_id: [],
};

let nonOrganizationFormOder = [
  "basicInformationContactName",
  "basicInformationAddressLine",
  "basicInformationCountry",
  "basicInformationState",
  "basicInformationCity",
  "basicInformationPincode",
  "basicInformationPanId",
];

const KycForm = () => {
  const dispatch = useDispatch();
  const [isChecked, setIsChecked] = useState(false);
  const { loadingRef } = useContext(TopLoaderContext);
  const [registries, setRegistries] = useState([]);
  const [form] = Form.useForm();
  const [documents, setDocuments] = useState(doumentsDefaultState);
  const [contactDocuments, setContactDocuments] = useState(
    conteactDoumentsDefaultState
  );
  const { userType } = useSelector((state) => state.authReducer);
  const [signaturePopup, setSignaturePopup] = useState(false);
  const [userKyc, setUserKyc] = useState({});
  const [isDisabledForm, setIsDisabledFrom] = useState(false);
  const [status, setStatus] = useState("Requested");
  const [contactDetailsRequired, setContactDetailsRequired] = useState("Yes");
  const [individualContact, setIndividualContact] = useState(true);
  const [signatureImageUrl, setSignatureImageUrl] = useState(null);
  const [filledLocation, setFilledLocation] = useState("");
  const [kycNotVerified, setKycNotVerified] = useState(false);
  const [remarks, setRemarks] = useState(false);

  const handleContactDetailsRequired = (e) => {
    setContactDetailsRequired(e.target.value);
  };

  const handleViewSignature = () => {
    window.open(signatureImageUrl, "_blank");
  };

  useEffect(() => {
    try {
      const fetchRegistries = async () => {
        const data = await getAllRegistries(dispatch);
        setRegistries(
          data.map(({ registryName }) => {
            return { value: registryName, label: registryName };
          })
        );
      };
      fetchRegistries();
    } catch (error) {
      console.log(error);
    }
    fetchUserKyc();
  }, []);

  const fetchUserKyc = async () => {
    try {
      let response = await getkyc(dispatch);

      if (response.success) {
        if (response.data.kyc_status === "Rejected") {
          setKycNotVerified(true);
          setIsDisabledFrom(false);
          setRemarks(response.data.admin_remarks);
        }
        form.setFieldsValue(fillkycTransformData(response.data));
        if (
          response.data.kyc_status === "In-Process" ||
          response.data.kyc_status === "Completed" ||
          response.data.kyc_status === "Requested"
        ) {
          setIsDisabledFrom(true);
          setStatus(response.data.kyc_status);
          if (response.data.organization) {
            setSignatureImageUrl(
              response.data.organization.org_documents.signature
            );

            setFilledLocation(
              response.data.organization.org_documents.location
            );
          }

          if (response.data.individual) {
            setSignatureImageUrl(
              response.data.individual.individual_documents
                .user_goverment_issued_id
            );
            setFilledLocation(
              response.data.individual.individual_documents.location
            );
          }
          if (response.data.individual) {
            setIsChecked(true);
            // console.log("url ",response.data.individual.individual_documents.goverment_issued_id)
            setTimeout(() => {
              form.setFieldsValue({
                basicInformationState:
                  response.data.individual.basicInfo.Address.State,
              });
            }, 200);
            setTimeout(() => {
              form.setFieldsValue({
                basicInformationCity:
                  response.data.individual.basicInfo.Address.City,
              });
            }, 300);
            setContactDocuments({
              goverment_issued_id: [
                {
                  url: response.data.individual.individual_documents
                    .goverment_issued_id,
                  name: "goverment issued id",
                },
              ],
            });
          } else {
            setContactDocuments({
              goverment_issued_id: [
                {
                  url: response.data.organization.org_documents
                    .goverment_issued_id,
                  name: "goverment issued id",
                },
              ],
            });
            setDocuments({
              organizationInformationCompanyRegisteredAddress: [
                {
                  url: response.data.organization.org_documents
                    .CompanyRegisteredAddress,
                  name: "Company Registered Address",
                },
              ],
              organizationInformationCompanyTaxId: [
                {
                  url: response.data.organization.org_documents.CompanyTaxId,
                  name: "Company Tax Id",
                },
              ],
              organizationInformationPanId: [
                {
                  url: response.data.organization.org_documents.PanId,
                  name: "PanId",
                },
              ],
              organizationInformationDunsNumber: [
                {
                  url: response.data.organization.org_documents.DunsNumber,
                  name: "Duns Number",
                },
              ],
            });
          }
        }
      }
      //  console.log("data",data);
    } catch (error) {}
  };

  const onSubmitSignature = async ({
    location,
    signature,
    contactDetailsRequired,
  }) => {
    contactDetailsRequired === "Yes"
      ? setIndividualContact(true)
      : setIndividualContact(false);
    try {
      const newData = {
        individualContact,
        ...userKyc,
        location,
        signature,
      };
      loadingRef.current.continuousStart();
      // console.log(newData);
      const data = await kyc(kycTransformData(newData), dispatch);
      if (data.success) {
        toast.success("Submitted Successfully!!!");
        // form.resetFields();
        setIsDisabledFrom(true);
        setDocuments(doumentsDefaultState);
        setSignaturePopup(false);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.log(error);

      toast.error(String(error.message));
    } finally {
      loadingRef.current.complete();
    }
  };

  const onSubmit = async (values) => {
    if (!isChecked) {
      for (let key in documents) {
        if (documents[key].length <= 0) {
          if (contactDetailsRequired === "No") {
            if ((documents.goverment_issued_id = [])) {
              continue;
            } else {
              toast.error("Please upload required documents to proceed further");
              return;
            }
          }
          if (contactDetailsRequired === "Yes") {
            if (documents.goverment_issued_id != []) {
              continue;
            } else {
              toast.error("Please upload required documents to proceed further");
              return;
            }
          }
        }
      }
    }

    const keys = Object.keys(documents);
    const documentsData = {};
    for (let i of keys) {
      documentsData[i] = documents[i][0]?.url || "";
    }

    if (values["contact-detail-required"] == "Yes") {
      if (contactDocuments["goverment_issued_id"].length <= 0) {
        toast.error(
          "Please upload contact person government issued identification document"
        );
        return;
      } else {
        documentsData["goverment_issued_id"] =
          contactDocuments["goverment_issued_id"][0]?.url || "";
      }
    }

    documentsData["signature"] = "https://www.google.com/";

    values["contactDetailsPhoneCode"] = "+" + values["contactDetailsPhoneCode"];
    if (isChecked) {
      const { state, country } = getCountryAndStateName(
        values.basicInformationCountry,
        values.basicInformationState
      );
      values["basicInformationCountry"] = country;
      values["basicInformationState"] = state;
      values["basicInformationContactDetailsPhoneCode"] =
        "+" + values["basicInformationContactDetailsPhoneCode"];

      if (values["contact-detail-required"] !== "Yes") {
        documentsData["goverment_issued_id"] =
          documents["user_goverment_issued_id"][0]?.url || "";

        values["contactDetailsPersonName"] =
          values["basicInformationContactName"];
        values["contactDetailsPhoneCode"] =
          values["basicInformationContactDetailsPhoneCode"];
        values["contactDetailsContactNumber"] =
          values["basicInformationContactDetailsContactNumber"];
        values["contactDetailsEmail"] =
          values["basicInformationContactDetailsEmail"];
        values["contactDetailsShortDescription"] = "NA";

        // PersonName: data.contactDetailsPersonName,
        // mobile_no: {
        //   PhoneCode: data.contactDetailsPhoneCode,
        //   ContactNumber: Number(data.contactDetailsContactNumber),
        // },
        // Email: data.contactDetailsEmail,
        // ShortDescription: data.contactDetailsShortDescription,
      }
    } else {
      let { state, country } = getCountryAndStateName(
        values.billingInformationCountry,
        values.billingInformationState
      );
      values["billingInformationCountry"] = country;
      values["billingInformationState"] = state;

      const { state: s, country: c } = getCountryAndStateName(
        values.organizationInformationCountry,
        values.organizationInformationState
      );
      values["organizationInformationCountry"] = c;
      values["organizationInformationState"] = s;
      values["organizationInformationPhoneCode"] =
        "+" + values["organizationInformationPhoneCode"];

      if (values["contact-detail-required"] !== "Yes") {
        documentsData["goverment_issued_id"] =
          documents["organizationInformationPanId"][0]?.url || "";

        values["contactDetailsPersonName"] =
          values["organizationInformationOrganizationName"];
        values["contactDetailsPhoneCode"] =
          values["organizationInformationPhoneCode"];
        values["contactDetailsContactNumber"] =
          values["organizationInformationContactNumber"];
        values["contactDetailsEmail"] = values["organizationInformationEmail"];
      }
    }

    const newData = {
      ...values,
      notAnOrganization: isChecked,
      documents: documentsData,
    };
    setUserKyc(newData);
    setSignaturePopup(true);

    // try {
    //   loadingRef.current.continuousStart();
    //   const newData = {
    //     ...values,
    //     notAnOrganization: isChecked,
    //     documents: documentsData,
    //   };
    //   console.log(newData)
    //   const data = await kyc(kycTransformData(newData), dispatch);
    //   if (data.success) {
    //     toast.success("Submitted Successfully!!!");
    //     form.resetFields();
    //     setDocuments(doumentsDefaultState);
    //     setSignaturePopup(true);
    //   } else {
    //     toast.error(data.message);
    //   }
    // } catch (error) {
    //   console.log(error);
    // }
    loadingRef.current.complete();
  };

  const onFinishFailed = (errorInfo) => {
    // Scroll to the first invalid field
    // custome logic for  non organization
    if (isChecked) {
      let index = -1;
      for (const items of nonOrganizationFormOder) {
        index = errorInfo.errorFields.findIndex(
          (field) => items === field.name[0]
        );
        if (index !== -1) {
          form.scrollToField(errorInfo.errorFields[index].name);
          break;
        }
      }

      if (index == -1) {
        form.scrollToField(errorInfo.errorFields[0].name);
      }
      // Scroll to the first invalid field
    } else {
      // Scroll to the first invalid field
      form.scrollToField(errorInfo.errorFields[0].name);
    }
  };

  return (
    <>
      <div className="text-2xl font-bold mb-4">
        {" "}
        {isDisabledForm ? `Your KYC is ${status}` : "Complete Your KYC"}
      </div>
      <div className="kyc_form  font-spaceGrotesk w-full bg-white rounded-2xl shadow-formShadow pb-12 h-[calc(100vh-6rem)] overflow-y-scroll no-scrollbar">
        <div className="pl-8 pr-52 ">
          {userType !== "buyer" && (
            <Checkbox
              className="pt-10"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
              disabled={isDisabledForm}
            >
              <p className="font-normal text-sm text-black">
                Not an Organization (Individual Seller)
              </p>
            </Checkbox>
          )}
          <Form
            initialValues={{ registry_details: [{}] }}
            autoComplete="off"
            noValidate
            className="font-spaceGrotesk"
            form={form}
            onFinish={onSubmit}
            onFinishFailed={onFinishFailed}
            disabled={isDisabledForm}
          >
            <AnimatePresence>
              {!isChecked && (
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <OrganizationForm
                    documents={documents}
                    setDocuments={setDocuments}
                    registries={registries}
                    form={form}
                    Country={Country}
                    State={State}
                    City={City}
                    isDisabledForm={isDisabledForm}
                  />
                  <BillingForm
                    form={form}
                    Country={Country}
                    State={State}
                    City={City}
                  />
                </motion.div>
              )}
            </AnimatePresence>

            {isChecked && (
              <BasicInformationForm
                form={form}
                registries={registries}
                Country={Country}
                shortDescription={contactDetailsRequired === "No" && true}
                documents={documents}
                setDocuments={setDocuments}
                isDisabledForm={isDisabledForm}
              />
            )}
            <ContactDetailsForm
              Country={Country}
              shortDescription={isChecked}
              documents={contactDocuments}
              setDocuments={setContactDocuments}
              contactDetailsRequired={contactDetailsRequired}
              setContactDetailsRequired={handleContactDetailsRequired}
              isDisabledForm={isDisabledForm}
            />
            <Form.Item
              name="checkbox"
              valuePropName="checked"
              rules={[
                {
                  required: true,
                  message: "Please accept the terms and conditions.",
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject(
                          "Please accept the terms and conditions."
                        ),
                },
              ]}
            >
              <Checkbox>
                <p className="font-normal text-sm">
                  Accept{" "}
                  <span className="text-blue-800">
                    Terms & Conditions, Policies & terms of use{" "}
                  </span>
                  to proceed
                </p>
              </Checkbox>
            </Form.Item>
            {!isDisabledForm && (
              <Button
                type="submit"
                color="blue"
                varient="rounded"
                className="w-52 h-12 px-16 mx-auto text-2xl text-white mt-12 block mb-12"
              >
                Save
              </Button>
            )}
            {isDisabledForm && (
              <div className="flex justify-center gap-10">
                <Button
                  color="blue"
                  varient="rounded"
                  className=" py-1 px-4 text-xs text-white "
                  onClick={handleViewSignature}
                >
                  view signature
                </Button>
                <div>
                  <label
                    htmlFor=""
                    className="border-2  px-2 py-1 rounded-xl text-xs"
                  >
                    Location :
                  </label>
                  <input
                    type="text"
                    value={filledLocation}
                    className=" border-b-2 mx-6 pl-2 text-gray-400"
                    disabled={true}
                  />
                </div>
              </div>
            )}
          </Form>
          {signaturePopup && (
            <div>
              <KycSignaturePopup
                open={signaturePopup}
                onCancel={() => setSignaturePopup(false)}
                userData={userKyc}
                onSubmit={onSubmitSignature}
              />
            </div>
          )}
        </div>
        {kycNotVerified && (
          <div>
            <div className="border-b-2 border-gray-500 mt-6 w-full"></div>
            <div className="px-8">
              <p className="text-red-500 text-xl mt-4 font-semibold">
                Your KYC is Rejected
              </p>
              <p className="mt-2">Reason :</p>
              <textarea
                rows="4"
                className="w-full border rounded-lg focus:outline-none p-2"
                style={{ resize: "none" }}
                value={remarks}
                disabled={true}
              />
              <p className="text-red-500 text-sm">
                now you can edit your kyc form according to the above reason
              </p>
              <ol className=" text-sm border-2 py-2 px-4 w-96 rounded-lg mt-2">
                Notes:{" "}
                <li className="text-red-500 text-sm ">
                  * upload files again while doing kyc
                </li>
                <li className="text-red-500 text-sm">
                  * select country, state & city again
                </li>
              </ol>
            </div>
            <div className="border-b-2 border-gray-500 mt-6 w-full"></div>
            {/* <p className="px-8 text-xl font-semibold mt-6 text-blue-800">
              Edit KYC Form :
            </p> */}
          </div>
        )}
      </div>
    </>
  );
};

export default KycForm;
